export const selectIsPassThroughUser = (store) => store?.user?.isPassThroughUser;
